import React from "react";
import "../styles/errorPage.style.css";
import { useAppScope } from "master";

export const ErrorComponent = ({
  title,
  message,
  image,
  btnLabel,
  onClick,
}) => {
  const { isMWCD } = useAppScope();

  return (
    <div className={`error-page-content ${isMWCD ? "mwcd" : ""}`}>
      <div className="error-content-block">
        <img src={image} alt="" />
        <h2 className="error-title">{title}</h2>
        <p className="error-description">{message}</p>
        {onClick && (
          <div className="error-page-action">
            <button className="btn btn-blue" onClick={onClick}>
              {btnLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
